import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';

import { WebApiBaseService } from '../../shared/web-api-base/web-api-base.service';
import { pedidoMayoristaModel } from './pedidoMayorista.model';
// import { eModoPantalla, paymentDataModel, pedidoMayoristaModel } from './pedidoMayorista.model';


@Injectable({
  providedIn: 'root'
})
export class pedidoMayoristaService extends WebApiBaseService {


  constructor(private http: HttpClient, private route: Router) {
    super();

  }
   getMinimaCantidad(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'pedidosCabecera/getMinimaCantidad');
   }

    getDescuento(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'pedidosCabecera/getDescuento');
   }

  

   getpedidoMayoristas(params:HttpParams): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'pedidosCabecera/List', {params});

  }
  getZonasDeEntrega(params:HttpParams): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'ZonasDeEntrega/Get', {params});

  }

  getReporteRemito( id:any):Observable<any> {

    return this.http.get(this.baseUrl + 'Reportes/getRemito/'+id, { responseType: 'blob' });
  
   }

  getFechas(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'EnviosCabecera/Get' );

  }
  SyncpedidoMayoristas( dias:string): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'pedidosCabecera/Sync/'+dias,  );

  }

  Pagar(pedidoMayorista:number): Observable<any[]> {
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Cache-Control': 'no-cache'
    });
    const options = { headers: httpHeaders, method: 'put' };
      return this.http.post<any>(this.baseUrl + 'pedidosCabecera/pagar',pedidoMayorista,options  );
  }

  Entregar(pedidoMayorista:number): Observable<any[]> {
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Cache-Control': 'no-cache'
    });
    const options = { headers: httpHeaders, method: 'put' };
      return this.http.post<any>(this.baseUrl + 'pedidosCabecera/Entregar',pedidoMayorista,options  );
  }
 Facturar(pedidoMayorista: number): Observable<any> {
  const httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  });

  return this.http.post<any>(
    this.baseUrl + 'pedidosCabecera/Facturar',
    pedidoMayorista, // esto está bien, porque Angular lo serializa automáticamente
    { headers: httpHeaders }
  );
}

  Anular(pedidoMayorista:number) {
  
      return this.http.delete<any>(this.baseUrl + 'pedidosCabecera/Delete/'+pedidoMayorista  );
  }

  GrabarAlta(pedidoMayorista:pedidoMayoristaModel): Observable<any[]> {
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Cache-Control': 'no-cache'
    });
    const options = { headers: httpHeaders, method: 'post' };
      return this.http.post<any>(this.baseUrl + 'pedidosCabecera',pedidoMayorista,options  );
  }

  


  GrabarModificacion( pedidoMayorista:pedidoMayoristaModel): Observable<any[]> {


      const httpHeaders = new HttpHeaders({
        'Content-Type' : 'application/json',
        'Cache-Control': 'no-cache'
      });
      const options = { headers: httpHeaders, method: 'put' };
      return this.http.put<any>(this.baseUrl + 'pedidosCabecera',pedidoMayorista,options  );
  
  }
   
  GrabarModificacionDetalle( idMadre:number,OrderProducts:any[]): Observable<any[]> {


    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Cache-Control': 'no-cache'
    });
    const options = { headers: httpHeaders, method: 'put' };
    return this.http.put<any>(this.baseUrl + 'pedidosCabecera/Modificar/'+idMadre,OrderProducts,options  );

}



 
  getEnterKeyActions() {
    return ['startEdit', 'moveFocus'];
  }
  
  getEnterKeyDirections() {
    return ['none', 'column', 'row'];
  }
  
  processBatchRequest(  changes: {}): Observable<any> {
    
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Cache-Control': 'no-cache'
    });
    const options = { headers: httpHeaders, method: 'post' };

    return this.http.post<any>(this.baseUrl + 'pedidosCabecera/Update', changes, options);
    
    
 
  }
 
 getProductos(params:HttpParams ): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'Productos/List', {params});
    
  }

  getHistorialPedidos(loadOptions: any): Observable<any> {
    let params = new HttpParams();

    const isNotEmpty = (value: any): boolean => {
      return value !== undefined && value !== null && value !== '';
    };

    for (const key in loadOptions) {
      if (loadOptions.hasOwnProperty(key) && isNotEmpty((loadOptions as any)[key])) {
        if (key === 'filter' || key === 'sort' || key === 'group' || key === 'totalSummary' || key === 'groupSummary') {
          params = params.set(key, JSON.stringify((loadOptions as any)[key]));
        } else {
          params = params.set(key, (loadOptions as any)[key].toString());
        }
      }
    }

    if (!params.has('requireTotalCount')) {
      params = params.set('requireTotalCount', 'true');
    }

    return this.http.get<any>(this.baseUrl + 'pedidosCabecera/List', { params });
  }

}
